export const hasPersistentWithNexus = (statePersistent) => {
    return ("nexus" in statePersistent &&
        typeof statePersistent.nexus === "object" &&
        statePersistent.nexus !== null);
};
export const hasConfidentialWithNexus = (stateConfidential) => {
    return ("nexus" in stateConfidential.account &&
        typeof stateConfidential.account.nexus === "object" &&
        stateConfidential.account.nexus !== null);
};
